import { render, staticRenderFns } from "./FilesHeader.vue?vue&type=template&id=fb384eaa&"
import script from "./FilesHeader.vue?vue&type=script&lang=js&"
export * from "./FilesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb384eaa')) {
      api.createRecord('fb384eaa', component.options)
    } else {
      api.reload('fb384eaa', component.options)
    }
    module.hot.accept("./FilesHeader.vue?vue&type=template&id=fb384eaa&", function () {
      api.rerender('fb384eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/files/FilesHeader.vue"
export default component.exports